import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ items }) => {
    return (
        <div className={` bg-sf-light-100 font-sf font-medium p-4 ml-1 overflow-auto h-[calc(100vh-60px)]`}>
            {items.map((item) => (
                <NavLink
                    key={item.id}
                    to={`/Settings/${item.name}`}
                    className={(isActive) =>
                        `${
                            isActive ? 'bg-white text-sf-gray-800' : 'text-sf-gray-500'
                        } no-underline hover:text-sf-gray-800 px-3 h-8 rounded cursor-pointer text-13 flex items-center ${
                            !item.enabled ? 'opacity-[0.35] pointer-events-none cursor-not-allowed' : ''
                        }`
                    }>
                    {item.name}
                </NavLink>
            ))}
        </div>
    );
};

export default React.memo(Sidebar);
